import React, { useState, useEffect } from "react";
import { Box, Typography, Button, TextField, Grid, InputAdornment, Link, ToggleButton, ToggleButtonGroup, CircularProgress } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { getOTP, setErrorMessage } from "../../redux/actions/appActions";
import { b2bLogin, signupEnquiry } from "../../redux/actions/b2bActions";
import { ROUTE_JOBS_DASHBOARD, ROUTE_VIDEO_DETAILS, ROUTE_REGISTER_COMPLETE } from "../../constants/routes";
import { useNavigate } from "react-router-dom";
import { APP_CUSTOM_ERROR } from "../../constants/AppVarConstants";
import moment from "moment";

const LoginClient = () => {
  return (
    <Box sx={{ bgcolor: "#756DE9", minHeight: "800px", padding: "50px" }}>
      <Grid
        container
        spacing={4}
        justifyContent="center"
        alignItems="flex-start"
        sx={{ display: "flex", flexDirection: { xs: "column", md: "row" } }}
      >
        <Grid item xs={12} md={6}>
          <LeftPanel />
        </Grid>
        <Grid item xs={12} md={6}>
          <RightPanel />
        </Grid>
      </Grid>
    </Box>
  );
};

const LeftPanel = () => {
  const images = [
    {
      src: "images/client-website/Group-2153.png",
      top: 672,
      left: 560,
      height: "114px",
      width: "94px",
    },
    {
      src: "images/client-website/Group-2156.png",
      top: 409,
      left: 540,
      height: "105px",
      width: "96px",
    },
    {
      src: "images/client-website/Group-2158.png",
      top: 678,
      left: 0,
      height: "93px",
      width: "77px",
    },
    {
      src: "images/client-website/Group-2160.png",
      top: 137,
      left: 520,
      height: "83px",
      width: "67px",
    },
    {
      src: "images/client-website/Group-2161.png",
      top: 603,
      left: 313,
      height: "80px",
      width: "80px",
    },
    {
      src: "images/client-website/Group-2162.png",
      top: 522,
      left: 37,
      height: "135px",
      width: "136px",
    },
    {
      src: "images/client-website/Ellipse-4.png",
      top: 700,
      left: 200,
      height: "11px",
      width: "10px",
    },
    {
      src: "images/client-website/Ellipse-8.png",
      top: 485,
      left: 386,
      height: "7px",
      width: "7px",
    },
    {
      src: "images/client-website/Ellipse-9.png",
      top: 322,
      left: 506,
      height: "7px",
      width: "7px",
    },
    {
      src: "images/client-website/Ellipse-10.png",
      top: 567,
      left: 226,
      height: "22px",
      width: "22px",
    },
    {
      src: "images/client-website/Ellipse-12.png",
      top: 593,
      left: 472,
      height: "9px",
      width: "9px",
    },
    {
      src: "images/client-website/Ellipse-13.png",
      top: 55,
      left: 443,
      height: "22px",
      width: "22px",
    },
  ];

  return (
    <Box>
      <img src="/images/client-website/seevi-logo.png" alt="SeeVi Logo" style={{ width: 139, height: 60 }} />
      <Typography
        variant="h3"
        component="h1"
        sx={{
          color: "#fff",
          fontWeight: 700,
          fontSize: { xs: 28, md: 38 },
          lineHeight: { xs: "40px", md: "55px" },
          mt: 4,
          textAlign: { xs: "center", md: "left" },
        }}
      >
        India’s first job match <br /> making platform
      </Typography>
      {images.map((image, index) => (
        <Box
          key={index}
          component="img"
          src={image.src}
          alt={`Image ${index + 1}`}
          sx={{
            position: "absolute",
            width: image.width,
            height: image.height,
            top: `${image.top}px`,
            left: `${image.left}px`,
          }}
        />
      ))}
      <Box sx={{ mt: 4 }}>
        {[
          "Browse fresh talent presented uniquely",
          "Screen better through video profiles",
          "Get SeeVI personality profiler report on candidates",
          "Know achievements beyond academics",
          "Hire sooner, smarter, sharper",
        ].map((item, index) => (
          <Box key={index} sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <img
              src="/images/client-website/client-tick.png"
              alt="Tick"
              style={{ width: 21, height: 21, marginRight: 10 }}
            />
            <Typography
              sx={{
                color: "#FCFCFF",
                fontWeight: 500,
                fontSize: { xs: 16, md: 18 },
                lineHeight: "25px",
              }}
            >
              {item}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

const RightPanel = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [timer, setTimer] = useState(0);
  const [getOtpClicked, setGetOtpClicked] = useState(false);
  const [resendDisabled, setResendDisabled] = useState(false);
  const [activeTab, setActiveTab] = useState<"login" | "register">("login");
  const [isLoginSubmitting, setIsLoginSubmitting] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Form for registered recruiter
  const {
    control,
    handleSubmit,
    getValues,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      mobileNumber: "",
      otp: "",
    },
  });

  // Form for new recruiter
  const {
    control: controlNew,
    handleSubmit: handleRegister,
    formState: { errors: errorsNew },
  } = useForm({
    defaultValues: {
      fullName: "",
      companyName: "",
      email: "",
      phoneNumber: "",
    },
  });

  useEffect(() => {
    if (timer > 0) {
      setResendDisabled(true);
      const countdown = setTimeout(() => setTimer(timer - 1), 1000);
      return () => clearTimeout(countdown);
    } else {
      setResendDisabled(false);
    }
  }, [timer]);

  const handleGetOTPClick = async () => {
    const isMobileValid = await trigger("mobileNumber"); // Only validate mobileNumber
    if (isMobileValid) {
      const mobileNumber = getValues("mobileNumber");
      setTimer(30);
      setResendDisabled(true);
      setGetOtpClicked(true);
      dispatch(getOTP({ nationalNumber: mobileNumber, countryCallingCode: "91" }));
    }
  };

  const onSuccess = (res: any) => {
    if (res?.roleDetail?.roleName === "seevi_admin".toUpperCase()) {
      navigate(ROUTE_VIDEO_DETAILS);
    } else {
      navigate(ROUTE_JOBS_DASHBOARD);
    }
  };

  const onSubmit = (data: any) => {
    const payload = {
      userName: data?.mobileNumber,
      otp: data?.otp,
    };

    setIsLoginSubmitting(true);
    dispatch(
      b2bLogin(
        payload,
        (res) => {
          setIsLoginSubmitting(false);
          onSuccess(res);
        },
        () => {
          setIsLoginSubmitting(false);
        }
      )
    );
  };

  const register = (data: any) => {
    const payload = {
      fullName: data.fullName,
      companyName: data.companyName,
      email: data.email,
      phoneNumber: data.phoneNumber,
      enquiryTime: moment().format("DD-MM-YYYY hh:mm A"),
    };

    setIsSubmitting(true);
    dispatch(
      signupEnquiry(
        payload,
        (res) => {
          setIsSubmitting(false);
          navigate(ROUTE_REGISTER_COMPLETE);
        },
        () => {
          setIsSubmitting(false);
          dispatch(setErrorMessage(APP_CUSTOM_ERROR));
        }
      )
    );
  };

  return (
    <Box
      sx={{
        width: { xs: "100%", md: 471 },
        minHeight: "710px",
        bgcolor: "#fff",
        borderRadius: 3,
        boxShadow: "0px 4px 20px 0px #00000033",
        p: { xs: 2, md: 4 },
      }}
    >
      <ToggleButtonGroup
        value={activeTab}
        exclusive
        onChange={(event, newValue) => {
          if (newValue !== null) {
            setActiveTab(newValue);
          }
        }}
        sx={{
          mb: 4,
          bgcolor: "#F9F9F9",
          borderRadius: "100px",
          "& .MuiToggleButtonGroup-grouped": {
            border: "1px solid transparent",
            borderRadius: "100px !important",
            "&.Mui-selected": {
              bgcolor: "transparent",
              color: "#756DE9",
              border: "1px solid #756DE9",
              "&:hover": {
                bgcolor: "transparent",
                border: "1px solid #756DE9",
              },
            },
            "&:not(.Mui-selected)": {
              color: "#999",
              bgcolor: "transparent",
              border: "1px solid transparent",
              "&:hover": {
                bgcolor: "transparent",
              },
            },
          },
        }}
      >
        <ToggleButton
          value="login"
          sx={{
            textTransform: "none",
            fontSize: "14px",
            fontWeight: 500,
            px: 3,
            py: 1.5,
          }}
        >
          I&apos;m registered recruiter
        </ToggleButton>
        <ToggleButton
          value="register"
          sx={{
            textTransform: "none",
            fontSize: "14px",
            fontWeight: 500,
            px: 3,
            py: 1.5,
          }}
        >
          I&apos;m a new recruiter
        </ToggleButton>
      </ToggleButtonGroup>

      {activeTab === "login" && (
        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
          <Typography
            variant="h6"
            sx={{
              color: "#222",
              fontWeight: 600,
              fontSize: { xs: 22, md: 26 },
              mb: 5,
              textAlign: { xs: "center", md: "left" },
            }}
          >
            We&apos;re glad you&apos;re aboard!
          </Typography>

      {/* Registered Mobile Number Field */}
          <Controller
            name="mobileNumber"
            control={control}
            rules={{
              required: "Mobile Number is required",
              pattern: {
                value: /^[0-9]{10}$/,
                message: "Enter a valid 10-digit mobile number",
              },
            }}
            render={({ field }) => (
              <TextField
                {...field}
                label="Registered Mobile Number"
                placeholder="Enter Mobile Number"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    marginTop: "-12px",
                    color: "#000",
                    fontSize: "16px",
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: "#1F2235",
                          boxShadow: "0px 0px 11px 2px #4B44D414 inset",
                          borderRadius: "100px",
                          width: "120px",
                          height: "60px",
                          fontSize: "18px",
                          color: "#fff",
                          textTransform: "none",
                        }}
                        onClick={handleGetOTPClick}
                        disabled={!getValues("mobileNumber") || getOtpClicked}
                      >
                        Get OTP
                      </Button>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  width: { xs: "100%", md: "471px" },
                  height: "60px",
                  borderRadius: "100px",
                  boxShadow: "0px 0px 11px 2px #4B44D414 inset",
                  mb: 6,
                }}
                error={!!errors.mobileNumber}
                helperText={errors.mobileNumber?.message}
              />
            )}
          />

      {/* Resend Code with Timer */}
          {getOtpClicked ? (
            <>
              <Controller
                name="otp"
                control={control}
                rules={{
                  required: "OTP is required",
                  pattern: {
                    value: /^[0-9]{4}$/,
                    message: "Enter a valid 4-digit OTP",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="Enter 4 Digit OTP"
                    placeholder="- - - -"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        marginTop: "-12px",
                        color: "#000",
                        fontSize: "16px",
                      },
                    }}
                    sx={{
                      width: { xs: "100%", md: "471px" },
                      height: "60px",
                      borderRadius: "100px",
                      boxShadow: "0px 0px 11px 2px #4B44D414 inset",
                  mb: 3,
                    }}
                    error={!!errors.otp}
                    helperText={errors.otp?.message}
                  />
                )}
              />
              <Box sx={{ display: "flex", alignItems: "center", mb: 5, mt: 2 }}>
                <img
                  src="/images/client-website/Group-resend.png"
                  alt="Resend Icon"
                  width={21}
                  height={21}
                  style={{ marginRight: "8px" }}
                />
                <Link
                  href="#"
                  underline="none"
                  onClick={(e) => {
                    e.preventDefault();
                    if (!resendDisabled) {
                      setTimer(30);
                      setResendDisabled(true);
                    }
                  }}
                  sx={{
                    color: resendDisabled ? "#A0A0A0" : "#1F2235",
                    pointerEvents: resendDisabled ? "none" : "auto",
                    fontSize: "16px",
                    fontWeight: 500,
                    textDecoration: "none",
                  }}
                >
                  Resend Code {timer > 0 ? `00:${timer < 10 ? `0${timer}` : timer}` : ""}
                </Link>
              </Box>
            </>
          ) : null}

      {/* Continue Button */}
          <Button
            variant="contained"
            disabled={isLoginSubmitting}
            sx={{
          bgcolor: "#8155FF",
              borderRadius: "100px",
              width: { xs: "100%", md: "471px" },
              height: "60px",
              fontSize: "18px",
              textTransform: "none",
              minWidth: "140px",
              "&:hover": {
                backgroundColor: "#5a4dbf",
                color: "#fff",
                borderColor: "#5a4dbf",
              },
              "&:disabled": {
                bgcolor: "#B0ABE6",
                color: "#fff",
              },
            }}
            type="submit"
          >
            {isLoginSubmitting ? (
              <>
                <CircularProgress size={22} sx={{ color: "#fff", mr: 1 }} />
                Logging in...
              </>
            ) : (
              "Continue"
            )}
          </Button>
        </Box>
      )}

      {activeTab === "register" && (
        <Box component="form" onSubmit={handleRegister(register)}>
          <Typography
            variant="h6"
            sx={{
              color: "#000000",
              fontWeight: 600,
              fontSize: { xs: 22, md: 26 },
              mb: 1,
              textAlign: { xs: "center", md: "left" },
            }}
          >
            Welcome to Seevi!
          </Typography>

          <Typography
            sx={{
              color: "#000000",
              fontWeight: 400,
              fontSize: "16px",
              mb: 3,
              textAlign: { xs: "center", md: "left" },
            }}
          >
            A SeeVi executive will reach out to you for next steps
          </Typography>

          <Controller
            name="fullName"
            control={controlNew}
            rules={{
              required: "Full Name is required",
              maxLength: {
                value: 250,
                message: "Full Name cannot exceed 250 characters",
              },
            }}
            render={({ field }) => (
              <Box sx={{ mb: "14px" }}>
                <Typography
                  sx={{
                    color: "#000",
                    fontSize: "14px",
                    fontWeight: 400,
                    mb: "4px",
                  }}
                >
                  Full Name
                </Typography>
                <TextField
                  {...field}
                  placeholder="Full Name"
                  variant="outlined"
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "100px",
                      height: "60px",
                      boxShadow: "0px 0px 11px 2px #4B44D414 inset",
                      "& fieldset": {
                        border: "none",
                      },
                      "& input:-webkit-autofill": {
                        WebkitBoxShadow: "0 0 0 1000px white inset",
                        WebkitTextFillColor: "#000",
                      },
                    },
                  }}
                  error={!!errorsNew.fullName}
                  helperText={errorsNew.fullName?.message}
                />
              </Box>
            )}
          />

          <Controller
            name="companyName"
            control={controlNew}
            rules={{
              required: "Company name is required",
              maxLength: {
                value: 200,
                message: "Company name cannot exceed 200 characters",
              },
            }}
            render={({ field }) => (
              <Box sx={{ mb: "14px" }}>
                <Typography
                  sx={{
                    color: "#000",
                    fontSize: "14px",
                    fontWeight: 400,
                    mb: "4px",
                  }}
                >
                  Company name
                </Typography>
                <TextField
                  {...field}
                  placeholder="Company Name"
                  variant="outlined"
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "100px",
                      height: "60px",
                      boxShadow: "0px 0px 11px 2px #4B44D414 inset",
                      "& fieldset": {
                        border: "none",
                      },
                      "& input:-webkit-autofill": {
                        WebkitBoxShadow: "0 0 0 1000px white inset",
                        WebkitTextFillColor: "#000",
                      },
                    },
                  }}
                  error={!!errorsNew.companyName}
                  helperText={errorsNew.companyName?.message}
                />
              </Box>
            )}
          />

          <Controller
            name="email"
            control={controlNew}
            rules={{
              required: "Official Email ID is required",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Enter a valid email address",
              },
            }}
            render={({ field }) => (
              <Box sx={{ mb: "14px" }}>
                <Typography
                  sx={{
                    color: "#000",
                    fontSize: "14px",
                    fontWeight: 400,
                    mb: "4px",
                  }}
                >
                  Official Email ID
                </Typography>
                <TextField
                  {...field}
                  placeholder="Official Email ID"
                  variant="outlined"
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "100px",
                      height: "60px",
                      boxShadow: "0px 0px 11px 2px #4B44D414 inset",
                      "& fieldset": {
                        border: "none",
                      },
                      "& input:-webkit-autofill": {
                        WebkitBoxShadow: "0 0 0 1000px white inset",
                        WebkitTextFillColor: "#000",
                      },
                    },
                  }}
                  error={!!errorsNew.email}
                  helperText={errorsNew.email?.message}
                />
              </Box>
            )}
          />

          <Controller
            name="phoneNumber"
            control={controlNew}
            rules={{
              required: "Phone Number is required",
              pattern: {
                value: /^[0-9]{10}$/,
                message: "Enter a valid 10-digit phone number",
              },
            }}
            render={({ field }) => (
              <Box sx={{ mb: 3 }}>
                <Typography
                  sx={{
                    color: "#000",
                    fontSize: "14px",
                    fontWeight: 400,
                    mb: "4px",
                  }}
                >
                  Phone Number
                </Typography>
                <TextField
                  {...field}
                  placeholder="0000 0000"
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <img
                            src="/images/IN.png"
                            alt="India"
                            style={{ width: 32, height: 24 }}
                          />
                          <Typography sx={{ color: "#000", fontWeight: 500 }}>
                            + 91
                          </Typography>
                        </Box>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "100px",
                      height: "60px",
                      boxShadow: "0px 0px 11px 2px #4B44D414 inset",
                      "& fieldset": {
                        border: "none",
                      },
                      "& input:-webkit-autofill": {
                        WebkitBoxShadow: "0 0 0 1000px white inset",
                        WebkitTextFillColor: "#000",
                      },
                    },
                  }}
                  error={!!errorsNew.phoneNumber}
                  helperText={errorsNew.phoneNumber?.message}
                  onChange={(e) => {
                    // Only allow numbers and limit to 10 digits
                    const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);
                    field.onChange(value);
                  }}
                />
              </Box>
            )}
          />

          <Button
            variant="contained"
            type="submit"
            disabled={isSubmitting}
            endIcon={isSubmitting ? <CircularProgress size="1.2rem" sx={{ color: "#fff" }} /> : null}
            sx={{
              bgcolor: "#756DE9",
              borderRadius: "100px",
              width: "100%",
              height: "60px",
              fontSize: "18px",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#5a4dbf",
                color: "#fff",
                borderColor: "#5a4dbf",
              },
              "&:disabled": {
                bgcolor: "#B0ABE6",
                color: "#fff",
              },
            }}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default LoginClient;
